import React from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { stringify } from "qs";
import { store } from "main/javascripts/store";
import { HeaderContainer } from "main/javascripts/containers/organisms/Header/HeaderContainer";
import {
  defaultStyles,
  extended,
  GLOBALS,
} from "main/javascripts/styles/globalStyle";
import i18n from "i18n";
import { HOST } from "main/javascripts/constants/Constants";
import { MainHead } from "main/javascripts/components/head/MainHead";
import { useConstructor } from "main/javascripts/hooks/common/useConstructor";
import { useUserAccount } from "main/javascripts/hooks/common/useUserAccount";
import { MainBlock } from "main/javascripts/components/atoms/Block/MainBlock";
import { SearchBlock } from "main/javascripts/components/search/SearchBlock";
import { SearchFlight } from "main/javascripts/features/lp/flightDstRegion/components/SearchFlight";
import {
  fetchLpFlightDstRegionsShowPage,
  initFlightDestination,
} from "main/javascripts/features/lp/flightDstRegion/lpFlightDstRegionSlice";
import { LpFlightDstRegion } from "main/javascripts/types/lpFlightDstRegion";
import { LpFlightDstRegionIndexMain } from "main/javascripts/features/lp/flightDstRegion/components/LpFlightDstRegionIndexMain";
import { Footer } from "main/javascripts/components/footer/Footer";

interface IProps {
  flightDestinationRegion?: LpFlightDstRegion.FlightDestinationRegion;
  metaTags: any;
  locale: string;
}
// loadVConsole(2000);
function FlightDstRegionsShow(props: IProps) {
  const { flightDestinationRegion, metaTags = {}, locale } = props;
  const { title, description, noindex } = metaTags;
  const origin = HOST;

  useConstructor(() => {
    if (flightDestinationRegion) {
      store.dispatch(
        initFlightDestination({
          flightDestinationRegion,
          metaTags,
        })
      );
    }
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
    extended.css(defaultStyles[GLOBALS]);
  });

  useUserAccount(store);

  return (
    <Provider store={store}>
      <MainHead
        origin={origin}
        title={title}
        description={description}
        noindex={!!noindex}
      />
      <I18nextProvider i18n={i18n}>
        <>
          <HeaderContainer />
          <MainBlock key={1}>
            <SearchBlock>
              <SearchFlight />
            </SearchBlock>
            <LpFlightDstRegionIndexMain />
          </MainBlock>
          <Footer />
        </>
      </I18nextProvider>
    </Provider>
  );
}

export async function getStaticProps(ctx) {
  const locale = ctx.locale;
  const param = ctx.params;
  const regionId = param.regionId;
  delete param.regionId;
  const paramString: string = stringify(param, { arrayFormat: "repeat" });
  const data = await store
    .dispatch(
      fetchLpFlightDstRegionsShowPage({
        id: regionId,
        param: paramString,
        isServerSide: true,
      })
    )
    .unwrap();

  return {
    props: {
      locale,
      ...data,
    },
    revalidate: 60,
  };
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export default FlightDstRegionsShow;
